/** 两套布局共用的会话数据: 当前用户 / 角色 / 余额 / 退出 */
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth-store";
import { useCurrentUser, useLogout, usePublicConfig } from "@/features/auth/hooks";

export const ROLE_LABEL: Record<string, string> = {
  user: "成员",
  company_admin: "公司管理员",
  super_admin: "超级管理员",
};

export function useShell() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const isAdmin = useAuthStore((s) => s.isAdmin)();
  const logoutMutation = useLogout();
  // 拉 /api/me 把余额 / 公司类型合并进 auth-store (登录响应里没有这些字段)
  const me = useCurrentUser();
  const config = usePublicConfig();
  const creditsEnabled = me.data?.credits_enabled ?? config.data?.credits_enabled ?? false;
  const isCompanyAdmin = user?.role === "company_admin";
  /** 余额充值入口: 仅 company_admin 且开启余额计费 */
  const showBilling = creditsEnabled && isCompanyAdmin;
  const balanceFen = me.data?.credits_fen ?? user?.credits_fen;
  /** 有所属公司、开启计费、余额已知时才显示余额 */
  const showBalance = !!user && creditsEnabled && user.company_id != null && balanceFen !== undefined;

  const logout = async () => {
    await logoutMutation.mutateAsync();
    navigate("/login", { replace: true });
  };

  return { user, isAdmin, isCompanyAdmin, creditsEnabled, showBilling, showBalance, balanceFen, logout };
}
